import {
    getCodePipeline,
    listCodePipelines
} from './queries';
import {
    deleteCodePipeline,
    importCodePipeline,
    importAllCodePipelines,
    migrateCodePipeline,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    DeleteCodePipeline,
    GetCodePipeline,
    ImportAllCodePipelinesResult,
    ImportCodePipeline,
    ListCodePipelines,
    MigrateCodePipeline,
} from "../types";
import {pipelinesClient} from "../../pipelines-api-integration/client";


const client = pipelinesClient;

export const fetchRecords = async (query: {
    nextToken?: string | null;
} = {}) => {
    const {nextToken} = query;
    const response = await client.graphql<GraphQLQuery<ListCodePipelines>>({
        query: listCodePipelines,
        variables: {nextToken},
    });
    return {
        items: response.data?.listCodePipelines.items ?? [],
        nextToken: response.data?.listCodePipelines.nextToken,
    };
};

export const fetch = async (name: string) => {
    const response = await client.graphql<GraphQLQuery<GetCodePipeline>>({
                                                                             query: getCodePipeline,
                                                                             variables: {name: name},
                                                                         });
    return response.data?.getCodePipeline;
};

export const deleteRecord = async (name: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteCodePipeline>>({
                                                                                query: (deleteCodePipeline),
                                                                                variables: {input: {name: name}},
                                                                            });
    return response.data?.deleteCodePipeline;
};

export const importPipeline = async (name: string) => {
    const response = await client.graphql<GraphQLQuery<ImportCodePipeline>>({
                                                                                query: importCodePipeline,
                                                                                variables: {input: {name: name}},
                                                                            });
    return response.data?.importCodePipeline;
};

export const importAll = async () => {
    const response = await client.graphql<GraphQLQuery<ImportAllCodePipelinesResult>>({
                                                                                          query: importAllCodePipelines,
                                                                                      });
    return response.data?.importAllCodePipelines;
};

export const migratePipeline = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<MigrateCodePipeline>>({
                                                                                  query: migrateCodePipeline,
                                                                                  variables: {input: {id: id}},
                                                                              });
    return response.data?.migrateCodePipeline;
};
